import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { PengeinstitutIndstilling } from '@features/pengeinstitutter/pi-indstilling/pengeinstitutindstilling.model';

@Injectable({
  providedIn: 'root',
})
export class PiIndstillingDatasource extends RestDatasource<PengeinstitutIndstilling> {
  override endpoint = '/api/admin/pengeinstitutindstillinger';

  pengeinstitutId = signal<number | undefined>(undefined);
  data = resource({
    params: () => this.pengeinstitutId(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify({
            pengeinstitutId: params,
          }),
        },
        abortSignal
      );
    },
  });
}
